<template>
  <div class="dilog" v-show="show" >
    <div class="body" v-if="!isOver">
      <div class="header">
        <div>看累了，做道题吧</div>
      </div>
      <div class="context">
        <div class="title">
          <span v-html="topic.content"></span>
          <span class="type">({{ topic.questionTypeName }})</span>
        </div>
        <div>
          <!-- 单选   -->
          <el-radio-group
            class="multiple"
            v-model="topic.bodyGroups[0].answerSelectedIndex"
            v-if="topic.bodyGroups[0].multiOptions === false"
            :disabled="disabled"
          >
            <el-radio
              :label="items.optionIndex"
              v-for="(items, index) in topic.bodyGroups[0].options"
              :key="index"
              style="display: flex"
            >
              <span style="display: flex">
                {{ optionIndex[items.optionIndex] }} .
                <span style="margin-left: 5px" v-html="items.content"></span>
              </span>
            </el-radio>
          </el-radio-group>
          <!-- 多选 -->
          <template v-else>
            <div v-for="(items, index) in topic.bodyGroups[0].options" :key="index">
              <el-checkbox v-model="items.answerChecked" :disabled="disabled">
                <span style="display: flex">
                  {{ optionIndex[items.optionIndex] }} .
                  <span style="margin-left: 5px" v-html="items.content"></span>
                </span>
              </el-checkbox>
            </div>
          </template>
          <div v-if="disabled">
            正确答案：
            <span v-if="topic.bodyGroups[0].multiOptions === true">{{ getMultipleAnswer(topic.bodyGroups[0].options) }}</span>
            <span v-else> {{optionIndex[topic.bodyGroups[0].selectedIndex]}}</span>
            <div style="display: flex; align-items: center" v-if="topic.analysis">
              <span class="q-analysis">解析：</span>
              <span v-html="topic.analysis" ></span>
            </div>
          </div>
        </div>
      </div>
      <div class="bottoms">
        <el-button type="primary" @click="save" size="mini">{{
          btnText
        }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "do-exercise",
  props: { topicData: { default: [] } },
  data() {
    return {
      optionIndex: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
      show: false,
      index: 0,
      disabled: false,
      btnText: "确定",
    };
  },
  computed: {
    topic: function () {
      return this.topicData[(this.isOver?0:this.index)]?.adultQuestion || {};
    },
    isOver:function(){
        return this.topicData.length==0||(this.index>=this.topicData.length)
    }
  },
  mounted() {},
  methods: {
    open() {
      if (this.isOver) {
        this.$emit("achieve", this.index + 1);
      } else {
        this.show = true;
      }
    },
    save() {
      if (!this.disabled) {
        if((typeof(this.topic.bodyGroups[0].answerSelectedIndex)!=='number'&&this.topic.bodyGroups[0].multiOptions === false)||(this.topic.bodyGroups[0].multiOptions === true&&!this.topic.bodyGroups[0].options.some(e=>e.answerChecked==true))){
             this.$message.error('请选择答案');
             return;
        }
        this.disabled = true;
        this.btnText = "关闭";
      } else {
        this.show = false;
        this.$emit("achieve", this.index + 1);
      }
    },
    getMultipleAnswer(options){
     return options.filter((e) =>e.checked).map(e=>this.optionIndex[e.optionIndex]).join(',')
    }
  },
  watch: {
    show: function (newVal, oldVal) {
      if (!newVal) {
        this.index =this.index+1;
        this.disabled = false;
        this.btnText = "确定";
      } 
    },
    topicData:function(newVal){
      this.index=0
    }
  },
};
</script>

<style scoped lang="scss">
.dilog {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 998;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.body {
  width: 500px;
  min-height: 300px;
  background: #fff;
  border-radius: 10px;
  position: relative;
}
.header {
  /* height: 40px; */
  padding: 15px;
  /* background: #ccc; */
  border-bottom: solid 1px #cacaca;
  font-size: 18px;
  line-height: 1;
  color: #303133;
}
.context {
  padding: 15px 15px 75px 15px;
  .title {
    display: flex;
    justify-content: space-between;
    .type {
      width: 80px;
      text-align: right;
    }
  }
}
.bottoms {
  padding: 15px;
  width: 100%;
  text-align: right;
  border-top: 1px solid #cacaca;
  position: absolute;
  bottom: 0;
}

::v-deep .el-checkbox {
  display: block;
}
</style>
